import { render, staticRenderFns } from "./PosterModal.vue?vue&type=template&id=52063efe&scoped=true"
import script from "./PosterModal.vue?vue&type=script&lang=ts"
export * from "./PosterModal.vue?vue&type=script&lang=ts"
import style0 from "./PosterModal.vue?vue&type=style&index=0&id=52063efe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52063efe",
  null
  
)

export default component.exports